import './ContactUs.css';

const ContactUs = () => (
  <section id="contact" className="home-contact" aria-labelledby="contact-title">
    <div className="container home-contact__container">
      <div className="home-contact__heading">
        <span>Connect with us</span>
        <h2 id="contact-title">Let’s start your learning journey</h2>
        <p>Have a question about a course or a session? Our team is here to help.</p>
      </div>
      <div className="home-contact__layout">
        <div className="home-contact__map"><iframe title="Thakur Capital location" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3768.770492698152!2d72.84624!3d19.161521!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b64de5fc543f%3A0xf475b8ac492cc830!2sShalimar%20Miracle%2C%2026%2C%20Road%20No.%204%2C%20Jawahar%20Nagar%2C%20Goregaon%20West%2C%20Mumbai%2C%20Maharashtra%20400104%2C%20India!5e0!3m2!1sen!2sus!4v1730545223014!5m2!1sen!2sus" loading="lazy" referrerPolicy="no-referrer-when-downgrade" /></div>
        <address className="home-contact__details">
          <div><span>Call us</span><a href="tel:+919867545497">+91 98675 45497</a></div>
          <div><span>Email us</span><a href="mailto:contact@thakurcapital.com">contact@thakurcapital.com</a></div>
          <div><span>Visit us</span><p>Shop No. 116, Shalimar Miracle, Road No. 4, next to Bank of India, Jawahar Nagar, Goregaon West, Mumbai – 400104</p></div>
        </address>
      </div>
    </div>
  </section>
);

export { ContactUs };
